import FieldTextareaAutosize, {StyledFieldTextareaAutosize} from './FieldTextareaAutosize';

export default FieldTextareaAutosize;
export {StyledFieldTextareaAutosize};
